import { IPartnerAddress } from 'typings';

export function formatPartnerAddress({
  addressLine1,
  addressLine2,
  countryCode,
  locality,
  postalCode,
  region,
}: IPartnerAddress) {
  const result: Array<string> = [];

  result.push(addressLine1);

  if (addressLine2) {
    result.push(addressLine2);
  }

  let cityStateZip = '';

  if (locality) {
    cityStateZip += locality;

    if (region || postalCode) {
      cityStateZip += ', ';
    }
  }

  if (region) {
    cityStateZip += region;

    if (postalCode) {
      cityStateZip += ' ';
    }
  }

  if (postalCode) {
    cityStateZip += postalCode;
  }

  result.push(cityStateZip);

  if (countryCode) {
    result.push(countryCode);
  }

  return result;
}
